export interface EvoFeedSubscriptions {
  new_autoconfirmed_bookings: boolean;
  new_same_day_autoconfirmed_bookings: boolean;
  new_enquiries: boolean;
  user_mentions: boolean;
  payment_disputes: boolean;
}

export interface UserPreferences {
  locale?: string;
  evo_feed_subscriptions: EvoFeedSubscriptions;
}

export type EvoFeedSubscriptionKey = keyof EvoFeedSubscriptions;

export const DEFAULT_USER_PREFERENCES: UserPreferences = {
  locale: "en-GB",
  evo_feed_subscriptions: {
    new_autoconfirmed_bookings: false,
    new_same_day_autoconfirmed_bookings: false,
    new_enquiries: false,
    user_mentions: false,
    payment_disputes: true
  }
};
